import BigImg from '../../components/BigImg.vue';
import {Toast} from "vant";

var that;
var timer;
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,

        };
    },
    components: {
        BigImg,
    },
    data() {
        return {
            coupLists: [ {key: 'sxk', name: '书香卡（365元）', path: '', icon: require('@/assets/cba/clqp.png')},
                {key: 'mxk', name: '墨香卡（520元）', path: '', icon: require('@/assets/cba/clqp.png')},
                {key: 'wxk', name: '文香卡（899元）', path: '', icon: require('@/assets/cba/clqp.png')},
            ],
            optionBookShop: [
                { text: '书香卡（365元）', value: 1 },
                { text: '墨香卡（520元）', value: 2 },
                { text: '文香卡（899元）', value: 3 },
            ],
            bookNumber: "",
            valueOption: "",
            memberId: this.$route.query.memberId,
        };
    },

    created() {
        that = this;
        this.getCouponList();
        // setInterval(() => { //每5秒刷新一次图表
        //     this.getDhGoodsInfoList();
        // }, 5000);
    },

    mounted() {
        // timer = setInterval(() => { //每5秒刷新一次图表
        //     this.getDhGoodsInfoList();
        // }, 5000);

    },
    unmounted() {
        clearInterval(timer);
    },
    methods: {
        getCouponList() {
            // console.log(this.test);
            // console.log(this.$route.query.memberId);
            this.$api.getCouponList({
                params: {
                    memberId: this.$route.query.memberId + '',
                },
                success: function(res) {
                    console.log("resres", res);
                    that.coupLists = res.data
                }
            })
        },

        jumpInfo(id) {
            this.$router.push({
                path: '/dyBookShopDetail',
                query: {
                    couponId: id,
                    memberId: this.$route.query.memberId
                }
            })
        },

        goUrl() {
            // this.$api.getEncryptMemberId({
            //     params: {
            //         memberId: this.memberId,
            //     },
            //     success: function (res) {
            //         console.log(":::encryptMemberId:", res.data)
            //         this.$router.push({
            //             path: '/dyBookShopRecords',
            //             query: {
            //                 memberId: res.data
            //             }
            //         })
            //     }.bind(this)
            // })
        },
        createBookShopNumber(){
            this.$router.push({
                path: '/dyBookShopNumberCreate'
            })
        },
        bookNumberExchange(){
            console.log("bookNumber:",  this.bookNumber);
            if(this.bookNumber !== "") {
                this.$api.bookNumberExchange({
                    params: {
                        memberId: this.memberId,
                        bookNumber: this.bookNumber,
                    },
                    success: function (res) {
                        console.log(":::success", res)
                        Toast(res.data);
                        this.bookNumber = '';
                    }.bind(this),
                    fail: function (res) {
                        console.log(":::fail", res)
                        Toast('兑换失败');
                    }
                })
            }else{
                Toast('请先输入兑换码');
            }
        }
    }
};